import secureLocalStorage from "react-secure-storage";
import { filterBy, orderBy, process } from "@progress/kendo-data-query";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React, { PureComponent } from "react";
import Api from "../../Services/Api";
import "../../Styles/RiskViews.scss";
import * as moment from "moment";
import { toastr } from "react-redux-toastr";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import MitigationApprovedCell from "./Component/MitigationApprovedCell";
import CostComponent from "./Component/CostComponent";
import ReductionProbability from "./Component/ReductionProbability";
import MitigationStatus from "./Component/MitigationStatus";
import ActionProgressPopup from "./Component/ActionProgressPopup";
import OwnerComponent from "./Component/OwnerComponent";
import ActionAlertStackHolderComponent from "./Component/ActionAlertStackHolderComponent";
import ProximityDate from "./Component/ProximityDate";
import ActualCompDate from "./Component/ActualCompDate";
import ProjCompDate from "./Component/ProjCompDate";
import OriginalCompDate from "./Component/OriginalCompDate";
import PercentageCompletion from "./Component/PercentageCompletion";
import SPICell from "./Component/SPICell";
import MitigationNameCell from "./Component/MitigationNameCell";
import MitigationColoumns from "./MitigationColoumns.json";
import MitigationCurrencyFormat from "./Component/MitigationCurrencyFormat";
import ColumnMenu from "../Dashboard/ColumnMenu";
import ActionType from "./Component/ActionType";
import ActionQualitativeImpact from "./Component/ActionQualitativeImpact";
import ActionRegisterFormView from "./Component/ActionRegisterFormView";
import { mapTree } from "@progress/kendo-react-treelist";
import Images from "../../Assets/Images";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import { NavLink } from "react-router-dom";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { CircularProgress } from "@material-ui/core";
import { Popup } from "@progress/kendo-react-popup";
import ActionTitle from "./Component/ActionTitle";

export default class RecentlyViewedActions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      sort: [],
      take: 10,
      skip: 0,
      filter: {
        logic: "and",
        filters: [],
      },
      data: [],
      impactMaster: [],
      impactColumns: [],
      // persistenceActionGrid: this.props.persistenceActionGrid,
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 10,
        skip: 0,
      },
      formEditFlag: false,
      showFormView: false,
      formData: {},
      orgUnit: {},
      riskDetails: {},
      updatedfield: 0
    };
  }
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  componentDidUpdate = (prevProps) => {
    if (this.props.mitigationData !== prevProps.mitigationData) {
      this.createDynamicCols(this.props.mitigationData);
    }
  }
  componentDidMount = () => {
    console.log("loaded");
    this.createDynamicCols(this.props.mitigationData);
  }
  createDynamicCols = async (products) => {

    try {
      let impactMasterTemp = [];
      let impactColumn = [];
      products.map((res, i) => {
        res["impactResponse"] = res.impactResponse ? res.impactResponse : [];
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });

        impactMasterTemp = [...impactMasterTemp, ...res.impactResponse];
        if (res.actualCompletionDate) {
          res.actualCompletionDate = new Date(
            res.actualCompletionDate
          );
        }
        if (res.originalCompletionDate) {
          res.originalCompletionDate = new Date(
            res.originalCompletionDate
          );
        }
        if (res.projectedCompletionDate) {
          res.projectedCompletionDate = new Date(
            res.projectedCompletionDate
          );
        }
        if (res.proximityDate) {
          res.proximityDate = new Date(res.proximityDate);
        }
        if (res.updatedDate) {
          res.updatedDate = new Date(res.updatedDate);
        }
        if (res.createdDate) {
          res.createdDate = new Date(res.createdDate);
        }
        if (res.closedDate) {
          res.closedDate = new Date(res.closedDate);
        }

        // if(res.approved===true||res.approved==="Yes"){
        //   res.approved=true;
        // }else{
        //   res.approved=false;
        // }
        if (res.actionAlertStakeHolders) {
          res.actionAlertStakeHolders = res.actionAlertStakeHolders.toString();
        }
      });
      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp = res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =
                temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;
            }
          });

        });
      }
      let columnsToShow = [];
      impactMasterTemp = impactMasterTemp.filter(
        (ele, ind) =>
          ind ===
          impactMasterTemp.findIndex(
            (elem) =>
              elem.name === ele.name && elem.impactType === ele.impactType
          )
      );
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <GridColumn
            field={item}
            title={"Change in " + this.getImpactUnit(item, impactMasterTemp)}
            width="100px"
            editable={true}
            filter={"numeric"}
            columnMenu={ColumnMenu}
            cell={(props) =>
              this.getImpactTypeComponent(
                item,
                props,
                "Threat",
                impactMasterTemp
              )
            }
          // cell={(props) => (
          //   <MitigationCurrencyFormat {...props} onEditCell={this.enterEdit} />
          // )}
          />
        ));
      }
      //  setImpactColumns(columnsToShow);
      this.setState({
        ...this.state,
        impactColumns: columnsToShow,
        data: products,
        mitigationDataTemp: products,
      });
    } catch (err) {
      console.error(err);
    }
  };

  getImpactTypeComponent = (name, props, isOpportunity, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == name);
    if (impactTemp && impactTemp.impactType == "Quantitative") {
      return (
        <MitigationCurrencyFormat
          {...props}
          onEditCell={this.enterEdit}
          isOpportunity={isOpportunity}
        />
      );
    } else {
      return <ActionQualitativeImpact {...props} onEditCell={this.enterEdit} heatMapCount={this.props.heatMapCount} />;
    }
  };

  getImpactUnit = (impact, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == impact);
    var res = impact;
    if (
      impactTemp &&
      impactTemp.name &&
      impactTemp.impactType == "Quantitative"
    ) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return res;
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
          ref: (td) => {
            const input = td && td.querySelector("input");
            const activeElement = document.activeElement;

            if (
              !input ||
              !activeElement ||
              input === activeElement ||
              !activeElement.contains(input)
            ) {
              return;
            }

            if (input.type === "checkbox") {
              input.focus();
            } else {
              input.select();
            }
          },
        }
        : {
          onClick: () => {
            this.enterEdit(dataItem, cellField);
          },
          onFocus: () => {
            this.enterEdit(dataItem, cellField);
          },
          tabIndex: "0",
        };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement, props) => {
    const riskRegisterActionId = this.state.updatedfield;

    const bgcolor = {
      backgroundColor: "rgba(0, 255, 76, 0.308)",
    }
    const trProps = {
      ...trElement.props,
      style: riskRegisterActionId == props.dataItem.riskRegisterActionId ? bgcolor : null,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        if (
          this.state.editField == "actionAlertStakeHolders" ||
          this.state.editField == "status"
        ) {
          return;
        }
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit:
        item.riskRegisterActionId === dataItem.riskRegisterActionId
          ? field
          : undefined,
    }));
    console.log("dataValue", dataValue);
    this.setState({
      data: dataValue,
      currentChangedValue: dataItem,
      editField: field,
    });
  };

  exitEdit = () => {
    const dataValue = this.state.data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data: dataValue,
    });
  };

  itemChange = (event) => {
    const changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.data.map((item) =>
      item.riskRegisterActionId === event.dataItem.riskRegisterActionId
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      tempObj: dataValue[0],
      data: dataValue,
    });
    //dirty check
    let dirtData = this.state.data.find(
      (item) => changedValue.riskRegisterActionId == item.riskRegisterActionId
    );
    if (
      dirtData &&
      changedValue[this.state.editField] == dirtData[this.state.editField]
    ) {
      this.exitEdit();
      return;
    } else {
      this.closeEditandSaveMitigation(changedValue);
    }
  };
  closeEditandSaveMitigation = async (data) => {
    try {
      this.setState({ editID: null, enterEditFlag: false });
      if (!data.riskRegisterId) {
        return;
      }
      var mitigationReq = {};
      var imapctList = [];
      var QualityImpact = [];
      for (let field in data) {
        if (MitigationColoumns.hasOwnProperty(field)) {
          mitigationReq[field] = data[field];
        } else {
          var impactReq = {};
          var qualReq = {};
          var impact = data.impactResponse.find((item) => item.name == field);
          if (impact && impact.impactType == "Quantitative") {
            impactReq["ImpactId"] = impact.impactId;
            impactReq["ProjectRiskActionId"] = data.riskRegisterActionId;
            var val = data[field];
            impactReq["Value"] = parseFloat(val);
            // await this.impactUpdate(impactReq);
            imapctList.push(impactReq);
          } else if (impact && impact.qualitativeImpactId != 0) {
            qualReq["ProjectRiskActionId"] = data.riskRegisterActionId;
            qualReq["QualitativeImpactId"] = impact.qualitativeImpactId;
            qualReq["QValue"] = data[field];
            QualityImpact.push(qualReq);
          }
        }
      }
      mitigationReq["impactResponse"] = imapctList;
      mitigationReq["QualityImpact"] = QualityImpact;
      await this.mitigationUpdate(mitigationReq);
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };
  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  mitigationUpdate = async (req) => {
    try {
      if (!req.name || req.name.trim() === "") {
        toastr.error("The name field should not be empty.");
        return;
      }
      this.setState({ loader: true });
      req.name = req.name ? req.name.slice(0, 30) : "";
      req.cost = parseFloat(req.cost);
      req.reductionFrequency = parseFloat(req.reductionFrequency);
      req.revisedProductionLoss = parseFloat(req.revisedProductionLoss);
      req.revisedProjectCostIncrease = parseFloat(
        req.revisedProjectCostIncrease
      );
      req.revisedProjectDurationIncrease = parseFloat(
        req.revisedProjectDurationIncrease
      );
      req.riskRegisterActionId = parseFloat(req.riskRegisterActionId);
      req.riskRegisterId = parseFloat(req.riskRegisterId);
      req.sharePriceReduction = parseFloat(req.sharePriceReduction);
      req.isOpen = req.isOpen === "Open" || req.isOpen == true ? true : false;
      req.approved = req.approved === "Yes" || req.approved === true ? true : false;
      req.spi = parseFloat(req.spi);
      if (
        req.inEdit == "percentageCompletion" &&
        req.percentageCompletion == 100
      ) {
        req.isOpen = false;
      }
      if (
        req.inEdit == "percentageCompletion" &&
        req.percentageCompletion == 100 &&
        !req.actualCompletionDate
      ) {
        this.setState({ loader: false });
        this.openActionCompletionDatePopup();
        return;
      }

      if (req.inEdit == "isOpen") {
        if (!req.isOpen && !req.actualCompletionDate) {
          this.setState({ loader: false });
          this.openActionCompletionDatePopup();
          return;
        } else {
          req.percentageCompletion =
            req.percentageCompletion == 100 ? 0 : req.percentageCompletion;
        }
      }
      if (req.inEdit != "status") {
        req.status = null;
      }

      if (req.inEdit == "isOpen") {
        if (!req.isOpen) {
          // req.actualCompletionDate = moment(new Date()).format("YYYY-MM-DD");
        } else {
          req.actualCompletionDate = null;
          req.percentageCompletion =
            req.percentageCompletion == 100 ? 0 : req.percentageCompletion;
        }
      }
      req.percentageCompletion = req.percentageCompletion
        ? req.percentageCompletion
        : 0;

      if (req.inEdit == "actualCompletionDate" && req.actualCompletionDate) {
        req.isOpen = false;
      }

      //Auto Fill Completion Date change starts
      if (!req.originalCompletionDate && req.projectedCompletionDate) {
        req.originalCompletionDate = req.projectedCompletionDate;
      }
      if (!req.projectedCompletionDate && req.actualCompletionDate) {
        req.projectedCompletionDate = req.actualCompletionDate;
        if (!req.originalCompletionDate) {
          req.originalCompletionDate = req.actualCompletionDate;
        }
      }
      if (req.actionType) {
        req.actionType = req.actionType === " [blank]" ? null : req.actionType;
      }
      req.originalCompletionDate = req.originalCompletionDate
        ? moment(req.originalCompletionDate).format("YYYY-MM-DD")
        : null;
      req.projectedCompletionDate = req.projectedCompletionDate
        ? moment(req.projectedCompletionDate).format("YYYY-MM-DD")
        : null;
      req.actualCompletionDate = req.actualCompletionDate
        ? moment(req.actualCompletionDate).format("YYYY-MM-DD")
        : null;
      req.proximityDate = req.proximityDate
        ? moment(req.proximityDate).format("YYYY-MM-DD")
        : null;
      // req.CreatedDate = req.CreatedDate
      //   ?req.createdDate = moment(req.CreatedDate).format("YYYY-MM-DD")
      //   : null;
      req.delayConsequence = req.delayConsequence
        ? req.delayConsequence.toString()
        : null;
      if (req.owner && typeof req.owner !== "string") {
        req["userId"] = req.owner.text === " [blank]" ? null : req.owner.value;
        req.owner = req.owner.text === " [blank]" ? null : req.owner.text;
      }
      req.actionAlertStakeHolders = this.processInput(req.actionAlertStakeHolders);
      req.createdDate = new Date();
      req.createdBy = parseInt(secureLocalStorage.getItem("loginUserId"));
      delete req["inEdit"];

      let response = await Api.createRegisterMitigation(req);
      if (response.status === 200) {
        // toastr.success(response.message);
        this.setState({ loader: false, updatedfield: req.riskRegisterActionId });
        this.closeActionCompletionDatePopup()
        this.props.refreshAction();
      } else {
        toastr.error(response.message);
        this.setState({ loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  CustomHeaderCell = (props) => {
    var val = this.getOriginalValueFromRisk(props.field);
    return (
      <span>
        <span title="Original Value"> {val.split("/")[0]}</span>
        <span className="yellowCell" title="Approved Value">
          {""} ({val.split("/")[1]})
        </span>
      </span>
    );
  };
  CustomHeaderCellForProbablity = (props) => {
    let riskval = 0; //this.props.dataItem.frequency;
    let actionVal = 0; //this.props.dataItem.reductionProbability;
    return (
      <span>
        <span title="Original Value"> {riskval}</span>
        <span className="yellowCell reductionProbVal" title="Approved Value">
          {""} ({actionVal ? actionVal : 0})
        </span>
      </span>
    );
  };
  sortChange = (event) => {
    this.setState({
      data: this.getProducts(event.sort),
      sort: event.sort,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.data, sort);
  };

  onColumnReorder = (event) => {
    try {
      let req = {
        ActionDetails: JSON.stringify(event.target.columnResize.columns),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      Api.persistHomeAction(req);
    } catch (err) {
      console.log(err);
    }
  };

  onColumnResize = (event) => {
    if (event.end) {
      try {
        let req = {
          ActionDetails: JSON.stringify(event.target.columnResize.columns),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
        };
        Api.persistHomeAction(req);
      } catch (err) {
        console.log(err);
      }
    }
  };

  getGridColum = (columns, editRoleFlag) => {
    let cellFieldName = columns.field;
    let width = columns.width;
    if (!cellFieldName) {
      return;
    } else if (cellFieldName == "approved") {
      return (
        <GridColumn
          field="approved"
          title="Approved"
          width={width}
          editor="boolean"
          filter={"boolean"}
          editable={editRoleFlag}
          reorderable={true}
          resizable={true}
          // columnMenu={ColumnMenu}
          cell={(props) => (
            <MitigationApprovedCell {...props} onEditCell={this.enterEdit} />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("approved")}
        />
      );
    } else if (cellFieldName == "name") {
      return (
        <GridColumn
          field="name"
          title="Action Title"
          width={width}
          editable={editRoleFlag}
          reorderable={false}
          orderIndex={0}
          resizable={false}
          locked={true}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ActionTitle pageName={"Home"} {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={`${this.setClassName("name")} no-drag`}
        />
      );
    } else if (cellFieldName == "number") {
      return (
        <GridColumn
          field="number"
          title="Action Number"
          width="120px"
          orderIndex={0}
          editable={false}
          reorderable={false}
          locked={true}
          columnMenu={ColumnMenu}
          headerClassName={`${this.setClassName("number")} no-drag`}
        />
      );
    } else if (cellFieldName == "isOpportunity") {
      return (
        <GridColumn
          field="isOpportunity"
          title="T/O"
          width={width}
          editable={false}
          cell={(props) =>
            props.dataItem.isOpportunity === "Threat" ? (
              <td>{props.dataItem.isOpportunity}</td>
            ) : (
              <td><span className="turquoiseBlue">{props.dataItem.isOpportunity}</span></td>
            )
          }
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("isOpportunity")}
        />
      );
    } else if (cellFieldName == "control") {
      return (
        <GridColumn
          field="control"
          title="Description"
          width={width}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("control")}
        />
      );
    } else if (cellFieldName == "externalReference") {
      return (
        <GridColumn
          field="externalReference"
          title="External Reference"
          width={width}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("externalReference")}
        />
      );
    } else if (cellFieldName == "actionType") {
      return (
        <GridColumn
          field="actionType"
          title="Action Type"
          width={width}
          editable={editRoleFlag}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          cell={(props) => (
            <ActionType
              {...props}
              dropDownData={
                this.props.actionTypeListForRisk
                  ? this.props.actionTypeListForRisk
                  : []
              }
              actionTypeListForRisk={
                this.props.actionTypeListForRisk
                  ? this.props.actionTypeListForRisk
                  : []
              }
              onEditCell={this.enterEdit}
            />
          )}
          headerClassName={this.setClassName("actionType")}
        />
      );
    } else if (cellFieldName == "cost") {
      return (
        <GridColumn
          field="cost"
          title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
          width={width}
          editable={editRoleFlag}
          filter={"numeric"}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <CostComponent {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("cost")}
        />
      );
    } else if (cellFieldName == "reductionFrequency") {
      return (
        <GridColumn
          field="reductionFrequency"
          title="Change in Probability (%)"
          editable={editRoleFlag}
          width={width}
          filter={"numeric"}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ReductionProbability {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("reductionFrequency")}
        />
      );
    } else if (cellFieldName == "ImpactFields") {
      return this.state.impactColumns;
    } else if (cellFieldName == "spi") {
      return (
        <GridColumn
          field="spi"
          title="% On Track"
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          width={width}
          filter={"numeric"}
          cell={(props) => <SPICell {...props} onEditCell={this.enterEdit} />}
          headerClassName={this.setClassName("spi")}
        />
      );
    } else if (cellFieldName == "percentageCompletion") {
      return (
        <GridColumn
          field="percentageCompletion"
          title="% Completion"
          width={width}
          editable={editRoleFlag}
          filter={"numeric"}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <PercentageCompletion {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("percentageCompletion")}
        />
      );
    } else if (cellFieldName == "originalCompletionDate") {
      return (
        <GridColumn
          field="originalCompletionDate"
          title="Original Completion Date"
          width={width}
          editor="date"
          format="{0:dd-MMM-yyyy}"
          filter={"date"}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <OriginalCompDate {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("originalCompletionDate")}
        />
      );
    } else if (cellFieldName == "projectedCompletionDate") {
      return (
        <GridColumn
          field="projectedCompletionDate"
          title="Projected Completion Date"
          width={width}
          editor="date"
          format="{0:dd-MMM-yyyy}"
          filter={"date"}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ProjCompDate {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("projectedCompletionDate")}
        />
      );
    } else if (cellFieldName == "actualCompletionDate") {
      return (
        <GridColumn
          field="actualCompletionDate"
          title="Actual Completion Date"
          width={width}
          editor="date"
          //editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ActualCompDate {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("actualCompletionDate")}
        />
      );
    } else if (cellFieldName == "proximityDate") {
      return (
        <GridColumn
          field="proximityDate"
          title="Proximity Alert Date"
          width={width}
          editor="date"
          format="{0:dd-MMM-yyyy}"
          filter={"date"}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ProximityDate {...props} onEditCell={this.enterEdit} />
          )}
          headerClassName={this.setClassName("proximityDate")}
        />
      );
    } else if (cellFieldName == "delayConsequence") {
      return (
        <GridColumn
          field="delayConsequence"
          title="Delay Consequence"
          width={width}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("delayConsequence")}
        />
      );
    } else if (cellFieldName == "alertDescription") {
      return (
        <GridColumn
          field="alertDescription"
          title="Alert Description"
          width={width}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("alertDescription")}
        />
      );
    } else if (cellFieldName == "actionAlertStakeHolders") {
      return (
        <GridColumn
          field="actionAlertStakeHolders"
          title="Alert StakeHolders"
          width={width}
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ActionAlertStackHolderComponent
              {...props}
              onEditCell={this.enterEdit}
              stackeHolderList={
                this.props.stackeHolderList ? this.props.stackeHolderList : []
              }
              exitEdit={this.exitEdit}
            //  editOrAdd={this.state.addActionbtnHideFlag}
            />
          )}
          headerClassName={this.setClassName("actionAlertStakeHolders")}
        />
      );
    } else if (cellFieldName == "owner") {
      return (
        <GridColumn
          field="owner"
          width={width}
          title="Owner"
          editable={editRoleFlag}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          cell={(props) => (
            <OwnerComponent
              {...props}
              onEditCell={this.enterEdit}
              dropDownData={
                this.props.ownerListForMitigation
                  ? this.props.ownerListForMitigation
                  : []
              }
            />
          )}
          headerClassName={this.setClassName("owner")}
        />
      );
    } else if (cellFieldName == "status") {
      return (
        <GridColumn
          field="status"
          width={width}
          title="Progress Status"
          editable={editRoleFlag}
          columnMenu={ColumnMenu}
          cell={(props) => (
            <ActionProgressPopup
              {...props}
              onEditCell={this.enterEdit}
              exitEdit={this.exitEdit}
            />
          )}
          headerClassName={this.setClassName("status")}
        />
      );
    } else if (cellFieldName == "isOpen") {
      return (
        <GridColumn
          field="isOpen"
          title="Status"
          width={width}
          // columnMenu={ColumnMenu}
          editor="boolean"

          cell={(props) => (
            <MitigationStatus {...props} onEditCell={this.enterEdit} />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("isOpen")}
        />
      );
    } else if (cellFieldName == "closedDate") {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("closedDate")}
        />
      );
    } else if (cellFieldName == "daysOverdue") {
      return (
        <GridColumn
          field="daysOverdue"
          title="Original Days Overdue"
          width="120px"
          editable={false}
          filter={"numeric"}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("daysOverdue")}
        />
      );
    }
    else if (cellFieldName == "projectedOverdueActionCount") {
      return (
        <GridColumn
          field="projectedOverdueActionCount"
          title="Projected Days Overdue"
          width="120px"
          editable={false}
          filter={"numeric"}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("projectedOverdueActionCount")}
        />
      );
    } else if (cellFieldName == "departments") {
      return (
        <GridColumn
          field={cellFieldName}
          title="departments"
          width={width}
          editable={true}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("departments")}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
        />
      );
    } else if (cellFieldName == "externalStatus") {
      return (
        <GridColumn
          field={cellFieldName}
          title="External Status"
          width={width}
          editable={true}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("externalStatus")}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
        />
      );
    } else if (cellFieldName == "weeklyReport") {
      return (
        <GridColumn
          field={cellFieldName}
          title="Weekly Report"
          width={width}
          editable={true}
          columnMenu={ColumnMenu}
          headerClassName={this.setClassName("weeklyReport")}
          cell={(props) => (
            <MitigationNameCell {...props} onEditCell={this.enterEdit} />
          )}
        />
      );
    }
    else {
      let imp =
        this.state.impactColumns &&
        this.state.impactColumns.find(
          (impact) => cellFieldName === impact.props.field
        );
      if (imp) {
        return imp;
      }
    }
  };

  getSelectedColumn = () => { };
  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.dataState.filter && this.state.dataState.filter.filters) {
      this.state.dataState.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  actionButtons = (event) => {
    let eventData = event;
    return (
      <td style={{ left: "42px", right: "0px" }}>
        <ul className="actionIcon">
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => this.editFormView(eventData.dataItem)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/riskmitigationdocs/${eventData.dataItem.riskRegisterActionId
                  }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
        </ul>
      </td>
    );
  };

  closeRiskFormView = (flag) => {
    this.setState({
      ...this.state,
      showFormView: false,
      formData: {},
      formEditFlag: false,
    });
    if (flag == "REFRESH") {
      this.props.refreshAction();
    }
  };
  addRiskDataFromForm = () => {
    // this.props.refreshRisk();
  };
  editFormView = (dataItem) => {
    try {
      let orgUnit = {};
      mapTree(this.props.organisationUnitList, "children", (item) => {
        if (item.unitId === dataItem.organisationId) {
          orgUnit = item;
        }
        return item;
      });

      this.setState({
        ...this.state,
        showFormView: true,
        formData: dataItem,
        formEditFlag: true,
        orgUnit: orgUnit,
        riskDetails: dataItem.riskRegister,
      });
    } catch (err) {
      console.error(err);
    }
  };
  handleActulaCompletionDate = (date) => {
    let temp = this.state.currentChangedValue;
    temp["actualCompletionDate"] = date;
    this.setState({
      ...this.state,
      currentChangedValue: temp,
    })
  }
  openActionCompletionDatePopup = () => {
    this.setState({ actionCompletionDatePopup: true });
  }
  closeActionCompletionDatePopup = () => {
    this.setState({ actionCompletionDatePopup: false });
  }
  render() {

    // this.createDynamicCols(this.props.mitigationData);
    return (
      <div className="riskViewCont">
        {this.state.showFormView === true && (
          <ActionRegisterFormView
            formEditFlag={this.state.formEditFlag}
            formData={this.state.formData}
            showFormView={this.state.showFormView}
            orgUnit={this.state.orgUnit}
            heatMapCount={this.props.heatmapCount}
            closeRiskFormView={this.closeRiskFormView}
            addRiskDataFromForm={this.addRiskDataFromForm}
            dropDownData={
              this.props.stackeHolderList ? this.props.stackeHolderList : []
            }
            ownerListForRisk={
              this.props.ownerListForMitigation
                ? this.props.ownerListForMitigation
                : []
            }
            actionTypeList={
              this.props.actionTypeListForRisk
                ? this.props.actionTypeListForRisk
                : []
            }
            riskDetails={this.state.riskDetails}
            role={this.state.orgUnit ? this.state.orgUnit.role : ""}
            {...this.props}
          />
        )}

        <div className="tblCont riskRegister dataGrids " id="homepageaction">
          <Grid
            data={process(this.state.data, this.state.dataState)}
            {...this.state.dataState}
            reorderable={this.state.data.length == 0 ? false : true}
            resizable={this.state.data.length == 0 ? false : true}
            pageable={true}
            onDataStateChange={(e) => {
              this.setState({ dataState: e.dataState });
            }}
            cellRender={this.cellRender}
            rowRender={this.rowRender}
            editField="inEdit"
            onItemChange={this.itemChange}
            onColumnReorder={this.onColumnReorder}
            onColumnResize={(e) => this.onColumnResize(e)}
            sortable={{
              allowUnsort: true,
              mode: "multiple",
            }}
            sort={this.state.sort}
            onSortChange={this.sortChange}
          >
            <GridColumn
              cell={this.actionButtons}
              width="65px"
              filterable={false}
              orderIndex={0}
              resizable={false}
              reorderable={false}
              headerClassName="no-drag"
            />
            <GridColumn
              field="organisationName"
              title="Workstream"
              width="180px"
              editable={false}
              orderIndex={0}
              locked={true}
              resizable={false}
              columnMenu={ColumnMenu}
              headerClassName={`${this.setClassName("organisationName")} no-drag`}
            />

            <GridColumn
              field="riskTitle"
              title="Risk Title"
              width="200px"
              editable={false}
              orderIndex={0}
              locked={true}
              resizable={false}
              columnMenu={ColumnMenu}
              headerClassName={`${this.setClassName("riskTitle")} no-drag`}
            />

            {this.props.persistenceActionGrid &&
              this.props.persistenceActionGrid.map((columns) =>
                this.getGridColum(columns, true)
              )}
            <GridColumn
              field="createdDate"
              title="Created Date"
              width="120px"
              editable={false}
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              // locked={true}
              columnMenu={ColumnMenu}
              headerClassName={this.setClassName("createdDate")}
            />
            <GridColumn
              field="createdByName"
              title="Created By"
              width="120px"
              editable={false}
              // locked={true}
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.data}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("createdByName")}
            />
            <GridColumn
              field="updatedDate"
              title="Updated Date"
              width="120px"
              editable={false}
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              // locked={true}
              columnMenu={ColumnMenu}
              headerClassName={this.setClassName("updatedDate")}
            />
            <GridColumn
              field="updatedBy"
              title="Updated By"
              width="120px"
              editable={false}
              // locked={true}
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.data}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("updatedBy")}
            />
          </Grid>
        </div>
        <Popup
          show={this.state.actionCompletionDatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont actualCompPopup">
            <h3>Action Update</h3>
            <div className="labelBlock">
              <label className="fieldLabel1">
                <span className="fieldTitle">Action Title :</span>
                {this.state.currentChangedValue?.name}
              </label>

              <label className="fieldLabel2">
                <span className="fieldTitle">Action Number : </span>
                {this.state.currentChangedValue?.number}
              </label>
            </div>
            <label className="fieldLabel3">
              <span className="fieldTitle">Actual Completion Date</span></label>

            <DatePicker
              format="dd-MMM-yyyy"
              onChange={(e) =>
                this.handleActulaCompletionDate(e.target.value)
              }
            />

            <div className="btnCont">
              <button
                onClick={() =>
                  this.closeEditandSaveMitigation(
                    this.state.currentChangedValue
                  )
                }
                type="button"
                className="deleteBtn"
              >
                Submit
              </button>
              <button
                onClick={this.closeActionCompletionDatePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
